export const AUTH_SIGN_OUT_PATH = '/api/auth/sign-out';
